<template>
  <div class="level-container" v-if="isMax === false">
    <div class="title">{{ data.name }}</div>
    <Progress
      class="progress"
      :percentage="data.per"
      pivot-text="0"
      color="#FA6400"
      v-if="isMax === false"
    />
    <div class="prohress-desc">
      <span class="left">{{ data.num }}{{ data.unit }}</span>
      <span class="right"
        >{{ data.label_start }}{{ data.all }}{{ data.label_end }}</span
      >
    </div>
    <!-- <div class="btn">会员权益</div> -->
  </div>
</template>

<script>
import { Progress } from 'vant'
import { levelMixins } from '@/views/Mine/Level/mixins/index.js'
export default {
  components: { Progress },
  mixins: [levelMixins]
}
</script>

<style lang="less" scoped>
.level-container {
  background: #f7b500;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.14);
  border-radius: 16px;
  text-align: center;
  padding: 16px 20px 20px;
  margin-bottom: 16px;
  .title {
    font-size: 28px;
    line-height: 36px;
    font-family: '锐字工房光明大黑简';
  }
  .progress {
    margin-top: 36px;
    background: #fff;
    height: 12px;
    border-radius: 6px;
    & /deep/ .van-progress__portion .van-progress__pivot {
      width: 32px;
      height: 32px;
      min-width: 32px;
      color: #fa6400;
    }
  }
  .prohress-desc {
    padding-top: 14px;
    display: flex;
    justify-content: space-between;
    font-size: 20px;
    line-height: 22px;
  }
  .btn {
    margin-top: 40px;
    font-size: 24px;
    line-height: 48px;
    border-radius: 24px;
    font-weight: 600;
    background-color: #ffd155;
  }
}
</style>